export enum WorkType {
  Open = 0,
  Close,
  Organization,
  BeforeOpen,
  AfterClose
}
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace WorkType {
  export function getValues(): string[] {
    return Object.keys(WorkType).filter(item => {
      return isNaN(Number(item)) && item != "getValues";
    });
  }
}
